import React from 'react';
import PropTypes from 'prop-types';

export default class ScrollDown extends React.PureComponent {
    static propTypes = {
        hide: PropTypes.bool
    };

    onClick = () => {
        $.fn.fullpage.moveTo(2);
    };

    render() {
        if (this.props.hide) {
            return (<div />);
        }

        return (
            <div role="presentation" className="scroll-down-wrapper" onClick={this.onClick}>
                <i className="icon-nextArrow" />
            </div>
        );
    }
}
